import { render, staticRenderFns } from "./ModalWebcheckout.vue?vue&type=template&id=65b8ef56&scoped=true&"
import script from "./ModalWebcheckout.vue?vue&type=script&lang=js&"
export * from "./ModalWebcheckout.vue?vue&type=script&lang=js&"
import style0 from "./ModalWebcheckout.vue?vue&type=style&index=0&id=65b8ef56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b8ef56",
  null
  
)

export default component.exports